import { createContext, useContext, useEffect, useRef } from "react";

export const BusquedaCtx = createContext({ query: "", setQuery: () => {}, setConfig: () => {} });

// Modo submit (Enter): búsquedas que navegan o disparan una acción puntual.
export function useBusquedaHeader(placeholder, soloNumeros, onBuscar) {
  const { setConfig } = useContext(BusquedaCtx);
  const ref = useRef(onBuscar);
  ref.current = onBuscar;
  useEffect(() => {
    setConfig({ placeholder, soloNumeros, buscar: (t) => ref.current(t) });
    return () => setConfig(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeholder, soloNumeros, setConfig]);
}

// Modo live: el buscador superior filtra en vivo la sección. Devuelve [query, setQuery].
export function useBusquedaLive(placeholder, { soloNumeros = false, initial = "" } = {}) {
  const { query, setQuery, setConfig } = useContext(BusquedaCtx);
  useEffect(() => {
    setConfig({ placeholder, soloNumeros, live: true });
    setQuery(initial);
    return () => setConfig(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeholder, soloNumeros]);
  return [query, setQuery];
}
